
import { platformBrowser } from '@angular/platform-browser';
import { WatchUsLiveModuleNgFactory } from '../../../compiled/App_Assets/scripts/watchuslive/watchuslive.module.ngfactory';

platformBrowser().bootstrapModuleFactory(WatchUsLiveModuleNgFactory);



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../watchuslive/watchuslive.main.aot.ts